import React, { useState, useEffect } from "react"
import { Input } from "../ui/input"
import {
    Search,
    Grid3X3,
    Type,
    Heading1,
    FileText,
    ImageIcon,
    Camera,
    Video,
    Hash,
    Calendar,
    MapPin,
    LayoutGrid,
    Link,
    ClipboardList,
    ChevronDown,
    ListOrdered, Clock, Navigation, Megaphone, LineChart, HelpCircle, Map
} from "lucide-react"
import ComponentCard from "./component_card";


const BaseCanvasEdit1 = ({
    base_on_classify_structure,  //使用目前最新結構 預設 false
    componentData = [],
    selectedComponent = null,
    onClick = () => { },
}) => {
    const [selectedComponentId, setSelectedComponentId] = useState(null);

    const extractIconName = (iconString) => {
        const match = iconString.match(/^<([A-Za-z0-9_]+)\s/)
        return match ? match[1] : null
    }
    const getLabelVaslue = (item) => {
        if (base_on_classify_structure) {
            return item?.title
        }
        else {
            return item?.component_definitions_classify_structure_type_data?.[0]
                // ?.name_language_data?.find(lang => lang.language_culture_code === "zh-tw")
                ?.name_language_data?.[0]
                ?.language_culture_value || ""
        }

    }

    useEffect(() => {
        onClick(selectedComponentId)
    }, [selectedComponentId])
    useEffect(() => {
        setSelectedComponentId(selectedComponent)
    }, [selectedComponent])
   

    return (
        <div className="bg-white border-r border-gray-200 flex flex-col h-full max-h-screen ">
            <div className="p-4 border-b border-gray-200">
                <div className="relative">
                    <Search className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <Input placeholder="搜尋元件..." className="pl-10" />
                </div>
            </div>

            <div className="flex-1 overflow-y-auto">
                <div className="p-4">
                    <div className="flex gap-4 mb-4">
                        <button className="text-sm font-medium text-gray-900 border-b-2 border-blue-500 pb-1">元件列表</button>
                    </div>

                    <div className="space-y-2">
                        {componentData.map((component) => {

                            return (
                                <ComponentCard
                                    icon={extractIconName(component?.icon)}
                                    showIcon={true}
                                    componentId={component?.component_definitions_id}
                                    componentName={getLabelVaslue(component)}
                                    componentDescription={component?.description}
                                    showComponentDescription={true}
                                    componentType={component?.component_type}
                                    componentCount={component?.count}
                                    showComponentCount={true}
                                    clicked={selectedComponentId === component?.component_definitions_id}
                                    draggable={true}
                                    onClick={(componentId, selectedElement) => {
                                        setSelectedComponentId(prev => prev === componentId ? null : componentId);
                                    }}
                                />
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BaseCanvasEdit1;
